import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Card } from './shared/Card';
import { CheckCircleIcon, LockIcon, TrendingUpIcon, BookOpenIcon, AwardIcon } from 'lucide-react';
export const JourneyMap: React.FC = () => {
  const [unlockedStages, setUnlockedStages] = useState(2); // First 2 stages unlocked
  const journeyStages = [{
    title: 'Self-Discovery',
    description: 'Understand your unique strengths and preferences',
    icon: <TrendingUpIcon size={24} data-id="element-691" />,
    tasks: [{
      name: 'Complete personality assessment',
      completed: true
    }, {
      name: 'Identify key strengths',
      completed: true
    }, {
      name: 'Reflect on past achievements',
      completed: true
    }]
  }, {
    title: 'Skills Development',
    description: 'Build the essential skills for your career path',
    icon: <BookOpenIcon size={24} data-id="element-692" />,
    tasks: [{
      name: 'Identify skill gaps',
      completed: true
    }, {
      name: 'Complete intro course',
      completed: false
    }, {
      name: 'Practice core techniques',
      completed: false
    }]
  }, {
    title: 'Portfolio Building',
    description: 'Create projects that showcase your abilities',
    icon: <AwardIcon size={24} data-id="element-693" />,
    tasks: [{
      name: 'Plan portfolio structure',
      completed: false
    }, {
      name: 'Complete first project',
      completed: false
    }, {
      name: 'Get expert feedback',
      completed: false
    }]
  }, {
    title: 'Professional Network',
    description: 'Connect with mentors and industry professionals',
    icon: <TrendingUpIcon size={24} data-id="element-694" />,
    tasks: [{
      name: 'Join professional communities',
      completed: false
    }, {
      name: 'Attend virtual meetup',
      completed: false
    }, {
      name: 'Schedule informational interview',
      completed: false
    }]
  }];
  const unlockNextStage = () => {
    if (unlockedStages < journeyStages.length) {
      setUnlockedStages(unlockedStages + 1);
    }
  };
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.5
  }} data-id="element-695">
      <div className="mb-8" data-id="element-696">
        <h1 className="text-2xl font-bold text-white mb-2" data-id="element-697">
          Your Career Journey Map
        </h1>
        <p className="text-[#B8C0E0]" data-id="element-698">
          Complete each stage to advance your cosmic career path
        </p>
      </div>
      <div className="relative" data-id="element-699">
        {/* Connection lines between journey stages */}
        <div className="absolute left-6 top-12 bottom-12 w-1 bg-[#3A506B] z-0" data-id="element-700"></div>
        <div className="space-y-6 relative z-10" data-id="element-701">
          {journeyStages.map((stage, index) => {
          const isUnlocked = index < unlockedStages;
          const isActive = index === unlockedStages - 1;
          return <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} data-id="element-702">
                <Card className={`relative ${isUnlocked ? '' : 'opacity-60'}`} data-id="element-703">
                  <div className="flex" data-id="element-704">
                    <div className={`w-12 h-12 rounded-full flex items-center justify-center mr-4 ${isActive ? 'bg-gradient-to-r from-[#7D56F4] to-[#19D3DA]' : isUnlocked ? 'bg-[#19D3DA]' : 'bg-[#3A506B]'}`} data-id="element-705">
                      {stage.icon}
                    </div>
                    <div className="flex-1" data-id="element-706">
                      <div className="flex justify-between items-center mb-2" data-id="element-707">
                        <h3 className="text-lg font-semibold" data-id="element-708">{stage.title}</h3>
                        {!isUnlocked && <LockIcon size={18} className="text-[#3A506B]" data-id="element-709" />}
                      </div>
                      <p className="text-[#B8C0E0] text-sm mb-4" data-id="element-710">
                        {stage.description}
                      </p>
                      <div className="space-y-2" data-id="element-711">
                        {stage.tasks.map((task, taskIndex) => <div key={taskIndex} className="flex items-center" data-id="element-712">
                            <div className={`w-5 h-5 rounded-full flex items-center justify-center mr-2 ${task.completed ? 'bg-[#19D3DA]/20 text-[#19D3DA]' : 'bg-[#1C2541] text-[#B8C0E0]'}`} data-id="element-713">
                              {task.completed ? <CheckCircleIcon size={14} data-id="element-714" /> : <span className="text-xs" data-id="element-715">{taskIndex + 1}</span>}
                            </div>
                            <span className={`text-sm ${task.completed ? 'line-through text-[#B8C0E0]' : 'text-white'}`} data-id="element-716">
                              {task.name}
                            </span>
                          </div>)}
                      </div>
                      {isActive && <button onClick={unlockNextStage} className="mt-4 bg-[#7D56F4] text-white text-sm font-medium py-2 px-4 rounded-full" data-id="element-717">
                          Complete Stage
                        </button>}
                    </div>
                  </div>
                </Card>
              </motion.div>;
        })}
        </div>
      </div>
    </motion.div>;
};